import { GATEWAY_LIST_FILTER_ALL } from '../constants/gatewayListFilters.const'

import type { GatewayListMobileFiltersStoreState } from './gateway-list-mobile-filters.type'

export const gatewayListMobileFiltersInitialState: GatewayListMobileFiltersStoreState = {
  openMenu: null,
  pending: {
    status: GATEWAY_LIST_FILTER_ALL,
    runtime: GATEWAY_LIST_FILTER_ALL,
    feed: GATEWAY_LIST_FILTER_ALL,
    environment: GATEWAY_LIST_FILTER_ALL,
  },
}
